import { render, staticRenderFns } from "./Director-Profile.vue?vue&type=template&id=26cf736b"
import script from "./Director-Profile.vue?vue&type=script&lang=js"
export * from "./Director-Profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports